<script>
import Base from './base.vue';
import autoAdd from '../mixin/auto-add';

export default {
  name: 'BUY_NOW',
  extends: Base,
  mixins: [autoAdd],
};
</script>
